export const getTargetClassName = (className, targetName) => {
    if (!className) {
        return '';
    }
    if (typeof className === 'string') {
        return className;
    }
    if (typeof className === 'object') {
        if (!targetName) {
            return className['root'] ?? '';
        }
        return className[targetName] ?? '';
    }
    return '';
};
//# sourceMappingURL=truncate.logic.js.map